import { render } from "./cp_guess.vue?vue&type=template&id=5c4a8a46&scoped=true"
import script from "./cp_guess.vue?vue&type=script&lang=js"
export * from "./cp_guess.vue?vue&type=script&lang=js"

import "./cp_guess.vue?vue&type=style&index=0&id=5c4a8a46&scoped=scoped&lang=less"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4a8a46"]])

export default __exports__